import _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNavigationContext } from '../../../global/ducks/app-context';
import { getOrganization, getOrganizations } from '../../../global/ducks/organization-prc-api';
import { NavigationContext } from '../../../global/models/app-context-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { InstitutionItem } from '../features/institutions/institution-model';
import { dispatchResetInstitutionClientNumber, dispatchSetCurrentInstitution, setInstituionList, setInstitutionClientNumber, setInstitutionGuid } from '../features/institutions/institution-slice';

export const processOrganization = (org: InstitutionItem) => {
	const copy = _.cloneDeep(org);
	copy.city = copy.mailing_address?.city;
	return copy;
};

export function useInstitutionList() {
	const dispatch = useDispatch();
	const institutionListLoaded = useSelector<TcsmStates, boolean>(state => state.institutionState?.institutionListLoaded);
	useEffect(() => {
		if (!institutionListLoaded) {
			dispatch(getOrganizations((respond) => {
				const organizations = respond.data?.organizations?.map(a => processOrganization(a));
				dispatch(setInstituionList(organizations));
				if (organizations?.length === 1) {
					dispatch(setInstitutionClientNumber(organizations[0].client_number));
					dispatch(setInstitutionGuid(organizations[0].guid));
					dispatch(setNavigationContext(NavigationContext.Institution));
					dispatch(getOrganization(organizations[0].client_number, dispatchSetCurrentInstitution(dispatch), dispatchResetInstitutionClientNumber(dispatch)));										
				}
			}, () => { dispatch(setInstituionList([]));}));
			
		}

	}, []);

	return institutionListLoaded;
}